import UsuarioGrupoTipoEnum from 'Enumerations/UsuarioGrupoTipoEnum'
import { IPerfil, UsuarioAtual } from 'Models/auth'

const usuarios = {
  verificaTransportadorasUsuario(usuario: UsuarioAtual): number[] | undefined {
    let cdsTransportadorasUsuario: number[] | undefined = undefined

    if (usuario.perfis?.length > 0) {
      const perfil: IPerfil = usuario.perfis[0] //Por enquanto, cada usuário pode ter somente um perfil

      if (
        perfil.tipo?.id === UsuarioGrupoTipoEnum.Transportadora &&
        usuario.cdsTransportadoras
      ) {
        cdsTransportadorasUsuario = [...usuario.cdsTransportadoras]
      }
    }

    return cdsTransportadorasUsuario
  },

  verificaTipoGrupoUsuario(
    usuario: UsuarioAtual,
  ): UsuarioGrupoTipoEnum | undefined {
    let tipoGrupoUsuario: UsuarioGrupoTipoEnum | undefined = undefined

    if (usuario.perfis?.length > 0) {
      const perfil: IPerfil = usuario.perfis[0] //Por enquanto, cada usuário pode ter somente um perfil

      if (perfil.tipo?.id) {
        tipoGrupoUsuario = perfil.tipo.id
      }
    }

    return tipoGrupoUsuario
  },
}

export default usuarios
